import { StatusIndicatorProps } from "@/common/components/Status/StatusIndicator";
import { assertNever } from "@/common/ts/typeHelpers";
import {
  AvailabilityStatus,
  GeneralStatusIdentifier,
  OperabilityStatus,
  UtilizationStatus,
  VehicleStatus,
} from "@/core/api/generated/v1";

import { AvailabilityStatusIndicator } from "./AvailabilityStatusIndicator";
import { OperabilityStatusIndicator } from "./OperabilityStatusIndicator";
import { UtilizationStatusIndicator } from "./UtilizationStatusIndicator";
import { VehicleStatusIndicator } from "./VehicleStatusIndicator";

interface Props {
  identifier: GeneralStatusIdentifier | undefined;
  value: string | undefined;
  indicatorProps?: Partial<StatusIndicatorProps>;
}

export function GeneralStatusIndicator({ identifier, value, indicatorProps }: Props) {
  if (!identifier || !value) {
    return null;
  }

  switch (identifier) {
    case GeneralStatusIdentifier.None:
      return null;
    case GeneralStatusIdentifier.VehicleStatus:
      return (
        <VehicleStatusIndicator status={value as VehicleStatus} indicatorProps={indicatorProps} />
      );
    case GeneralStatusIdentifier.AvailabilityStatus:
      return (
        <AvailabilityStatusIndicator
          status={value as AvailabilityStatus}
          indicatorProps={indicatorProps}
        />
      );
    case GeneralStatusIdentifier.OperabilityStatus:
      return (
        <OperabilityStatusIndicator
          status={value as OperabilityStatus}
          indicatorProps={indicatorProps}
        />
      );
    case GeneralStatusIdentifier.UtilizationStatus:
      return (
        <UtilizationStatusIndicator
          status={value as UtilizationStatus}
          indicatorProps={indicatorProps}
        />
      );
    default:
      assertNever(identifier);
  }
}
